export const uiTranslations = {
  en: {
    common: {
      close: 'Close',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      delete: 'Delete',
      confirm: 'Confirm',
      reject: 'Reject',
      approve: 'Approve',
      approved: 'Approved',
      skip: 'Skip',
      onhold: 'Onhold',
      failedInterview: 'Fail Int.',
      view: 'View',
      'n/a': 'N/A',
      name: 'Name',
      email: 'Email',
      contact: 'Contact',
      dashboard: 'Dashboard',
      messages: 'Messages',
      logout: 'Logout',
      language: 'Language',
      english: 'English',
      chinese: '中文 (Chinese)',
      applicant: 'Applicant',
      admin: 'Admin',
      you: 'You',
      justNow: 'Just now',
      minutesAgo: '{n} minute(s) ago',
      hoursAgo: '{n} hour(s) ago',
      daysAgo: '{n} day(s) ago',
      allFieldsRequired: 'All fields are required.',
      messageSent: 'Message sent successfully.',
      loginFailed: 'Login failed.',
      noDescription: 'Description is not available for this role.',
      applicationNo: 'Application No.',
      noPosition: 'No position'
    },
    category: {
      intro: 'Explore the different roles and services available on Helport. Choose the category that fits your skills and interests.'
    },
    sidebar: {
      helport: 'Helport',
      recruitmentHub: 'Recruitment Hub',
      headAdmin: 'Head Admin',
      menu: 'Menu',
      settings: 'Settings',
      adminControl: 'Admin Control',
      applicantMonitor: 'Applicant Monitor',
      messages: 'Messages',
      account: 'Account',
      jobDescription: 'Job Description',
      createAccounts: 'Create Accounts',
      interviewers: 'Interviewers',
      onHold: 'On Hold',
      jobOffer: 'Job Offer',
      hired: 'Hired',
      pooling: 'Pooling',
      passedInterview: 'Passed Interview',
      failedInterview: 'Failed Interview',
      retracted: 'Retracted',
      requirementsGuard: 'Requirements Guard'
    },
    admin: {
      heroEyebrow: 'Helport Philippines · Recruitment',
      heroTitle: 'Head Admin Dashboard',
      heroSubtitle: 'Welcome back, {name}. Track applications, assign interviewers, and manage your hiring pipeline from one place.',
      totalApplicants: 'Total Applicants',
      inReview: 'In Review',
      applicantMonitor: 'Applicant Monitor',
      monitorDesc: 'Live overview of all application statuses across departments.',
      showMonitorStats: 'Show status overview',
      hideMonitorStats: 'Hide status overview',
      monitorToggleSummary: '{total} total · {review} in review',
      appsForReview: 'Applications for Review',
      queueCount: '{n} application(s) in your queue',
      noAssigned: 'No applicants are assigned to you yet. Head Admin will assign applicants from Interviewer Management.',
      noDepartmentQueue: 'No applications in your department queue yet.',
      noPending: 'No pending applications.',
      interviewedByLabel: 'Interviewed by',
      alreadyInterviewedBy: 'Already being handled by {name}.',
      viewResume: 'View Digital Resume',
      closeResume: 'Close Resume',
      reviewDetails: 'Review Full Details',
      hideDetails: 'Hide All Details',
      remarksPlaceholder: 'Type remarks here so Head Admin can review them...',
      saveRemarks: 'Save Remarks',
      remarksSaved: 'Remarks saved successfully.',
      remarksSaveFailed: 'Failed to save remarks.',
      savedRemarksHistory: 'Saved remarks:',
      historyRemarks: 'History / Remarks:',
      recruiterRemarks: 'Recruiter / Interviewer Remarks',
      createAdminTitle: 'Create Accounts',
      createAdminDesc: 'Create and manage department admin accounts across the organization.',
      createDepartmentAccount: 'Create Department Account',
      createAdminAccountBtn: 'Create Admin Account',
      selectRole: 'Select Role',
      selectPositionDept: 'Select Position / Department',
      noRegisteredAccounts: 'No registered accounts found yet.',
      registeredAccountsCount: '{n} registered account(s)',
      searchRegisteredAccounts: 'Search by name, email, or position…',
      registeredAccountsSearchEmpty: 'No accounts match your search.',
      editAdminTitle: 'Edit Admin',
      changePasswordTitle: 'Change Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      saveChanges: 'Save Changes',
      changePasswordBtn: 'Change Password',
      registeredAccounts: 'Registered Accounts',
      interviewerTitle: 'Interviewers',
      interviewerDesc: 'Manage interviewers and their assigned applicants across different departments.',
      interviewerDescAuto: 'Assign applicants to HR and Client interviewers. Team Leader and Operations share a department queue and any member can act on applications.',
      deptApplications: 'Applications in Queue',
      deptStageActivity: 'Who moved applications',
      noPendingInDept: 'No applications waiting in this department.',
      noStageActivityYet: 'No application moves recorded in this department yet.',
      noHandledApplicantsYet: 'This member has not moved any applications yet.',
      handledBy: 'Handled by {name}',
      awaitingAction: 'Awaiting action',
      teamMembers: 'Team Members',
      noInterviewersInDept: 'No interviewers found in this department.',
      assignNewApplicant: 'Assign New Applicant',
      assignApplicantLabel: 'Assign Applicant',
      selectApplicant: 'Select an applicant...',
      noAssignableApplicants: 'No applicants available to assign at this stage.',
      savingAssignment: 'Saving...',
      assignedApplicantsCount: 'Assigned ({n})',
      interviewedApplicantsCount: 'Moved ({n})',
      deptQueueCount: '{n} pending',
      noInterviewsYet: 'No applicants assigned yet',
      searchInterviewers: 'Search by name or email…',
      recentMoves: 'Recent moves',
      assignShort: 'Assign',
      memberSingular: 'Member',
      memberPlural: 'Members',
      deptHr: 'HR',
      deptOps: 'Operations',
      deptTl: 'Team Leader',
      deptClient: 'Client',
      onHoldTitle: 'On Hold',
      onHoldDesc: 'Review applicants currently on hold before advancing them to the formal job offer stage.',
      onHoldCount: 'Applications on hold',
      onHoldEmpty: 'There are no applicants currently on hold.',
      onHoldRemarksPlaceholder: 'Type recruiter remarks here...',
      onHoldFields: {
        applicantName: 'Name of Applicant (Last Name, First Name, Middle Name, Suffix)',
        positionRole: 'Position/Role',
        mobileNo: 'Mobile No.',
        emailAddress: 'E-mail address',
        residentialAddress: 'Residential Address',
        dateOfApplication: 'Date of Application',
        lastInterview: 'Last Interview Date/Assessment',
        rehireEligibility: 'Rehire Eligibility (Y/N)',
        reemploymentCount: 'Re-employment Count (0-5)',
        sourceOfReferral: 'Source of Referral',
        referredBy: 'Referred by:',
        cvResume: 'CV/Resume',
        dateOfBirth: 'Date of Birth',
        gender: 'Gender',
        tin: 'Tax Identification No.',
        sss: 'SSS No.',
        phic: 'PHIC No.',
        hdmf: 'HDMF No.',
        nbiStatus: 'NBI Status',
        recruitersRemarks: "Recruiter's Remarks"
      },
      jobOfferTitle: 'Job Offer',
      jobOfferDesc: 'Review applicants who have already been issued a job offer.',
      offersIssued: 'Offers Issued',
      jobOfferEmpty: 'There are no applicants in the Job Offer stage.',
      jobOfferRemarksPlaceholder: 'Type final recruiter remarks here...',
      recruitersFinalRemarks: "Recruiter's Final Remarks",
      hiredTitle: 'Hired',
      hiredDesc: 'Track hired applicants and send onboarding requirements they need to submit.',
      hiredCount: 'Hired',
      hiredEmpty: 'There are no hired applicants yet.',
      hiredRemarksPlaceholder: 'Add onboarding or final remarks here...',
      hiredRequirementsTitle: 'Onboarding Requirements to Submit',
      hiredRequirementsDesc: 'Review each requirement below and notify the applicant to submit any pending documents.',
      requirementSubmitted: 'Submitted',
      requirementPending: 'Pending',
      sendRequirementNotice: 'Send Notice',
      sendAllPendingRequirements: 'Send All Pending Requirements',
      hiredPendingCount: '{n} pending',
      poolingTitle: 'Pooling',
      poolingDesc: 'Review applicants currently in the talent pooling stage.',
      inPooling: 'In Pooling',
      poolingEmpty: 'There are no applicants in the Pooling stage.',
      passedInterviewTitle: 'Passed Interview',
      passedInterviewDesc: 'Review applicants who passed their interview.',
      passedInterviewEmpty: 'There are no applicants marked as Passed Interview.',
      failedInterviewTitle: 'Failed Interview',
      failedInterviewDesc: 'Review applicants who did not pass their interview.',
      failedInterviewEmpty: 'There are no applicants marked as Failed Interview.',
      returnToInterview: 'Return to Interview',
      noInterviewRemarks: 'No interview remarks recorded.',
      retractedTitle: 'Retracted',
      retractedDesc: 'Review applicants who have retracted their applications.',
      retractedCount: 'Retracted',
      retractedEmpty: 'There are no retracted applications.',
      segment: 'Segment',
      assessment: 'Assessment',
      voiceScore: 'Voice Score',
      overallScore: 'Overall',
      exerciseScores: 'Exercise Breakdown',
      noAssessmentYet: 'No assessment yet',
      scoreExcellent: 'Excellent',
      scoreGood: 'Good',
      scoreFair: 'Fair',
      scoreNeedsWork: 'Needs Work',
      englishConfidenceShort: 'English Confidence',
      completedTrainingShort: 'Training Done',
      assessmentNotes: 'Applicant Notes',
      exGreeting: 'Greeting',
      exEmpathy: 'Empathy',
      exHold: 'Hold',
      exClosing: 'Closing',
      assessmentStatus: 'Status',
      retractedRemarksPlaceholder: 'Type final recruiter remarks here...',
      guardTitle: 'Requirements Guard',
      guardDesc: 'Monitor applicants with missing or incomplete required documents.',
      guardEmpty: 'All monitored applications currently meet the requirement checks.',
      flagged: 'Flagged',
      emailAddress: 'Email Address:',
      contactNumber: 'Contact Number:',
      applicationDate: 'Application Date:',
      positionNotSpecified: 'Position not specified',
      missingDocuments: 'Missing Documents:',
      issueJobOffer: 'Issue Job Offer',
      assignedAccountLabel: 'Assigned Account:',
      accountUnassigned: 'Unassigned',
      markHired: 'Mark as Hired',
      markRetracted: 'Retracted',
      retractConfirm: 'Retract application for {name} (Application No. {no})? All submitted answers and requirements will be deleted. Only the name and application number will be kept.',
      searchApplicationNo: 'Search by Application No.',
      retractedSearchEmpty: 'No retracted applications match this application number.',
      sendNotification: 'Send Notification',
      noFileAlert: 'No uploaded file was found for this document. Please ask the applicant to re-submit their attachments.',
      statTotal: 'Total Applicants',
      statPendingHr: 'Pending HR',
      statPendingOps: 'Pending Operations',
      statPendingTl: 'Pending Team Leader',
      statPendingClient: 'Pending Client',
      statPendingHeadAdmin: 'Pending Head Admin',
      pipelineHr: 'HR',
      pipelineOperations: 'Operations',
      pipelineTeamLeader: 'Team Leader',
      pipelineClient: 'Client',
      pipelineHeadAdmin: 'Head Admin',
      pipelineWaitingFor: 'Waiting for {stage} approval before you can review.',
      pipelineRejected: 'Applicant was rejected and will not proceed further.',
      pipelineFailedInterview: 'Applicant failed the interview and will not proceed further.',
      pipelineAlreadyPassed: 'This applicant has already passed your review stage.',
      pipelineNotYourTurn: 'Not yet your turn to review this applicant.',
      pipelineHeadAdminWaiting: 'Applicant is still in the department review pipeline.',
      statHired: 'Hired',
      statOnhold: 'On Hold',
      statRejected: 'Rejected',
      statJobOffer: 'Job Offer',
      statPooling: 'Pooling',
      statPassedInterview: 'Passed Interview',
      statFailedInterview: 'Failed Interview',
      statusPassed: 'Passed',
      statusFailed: 'Failed',
      statRetracted: 'Retracted',
      messagesSubtitleAdmin: 'Shared inbox for Head Admin and HR. See who is chatting with each applicant.',
      newApplicantChatTitle: 'New chat from {name}',
      newApplicantChatBody: 'An applicant sent a new message.',
      messagesSubtitleAssigned: 'Messages from applicants assigned to you appear here.',
      searchApplicants: 'Search applicants by name or email',
      noMessagesAdmin: 'No messages have been submitted yet.',
      noMessagesAssigned: 'No messages from your assigned applicants yet.',
      interviewScheduleLabel: 'Interview Schedule',
      interviewDateLabel: 'Date',
      interviewTimeLabel: 'Time',
      currentInterviewDate: 'Scheduled: {date}',
      setInterviewDate: 'Set Interview Date',
      interviewDateSaving: 'Saving...',
      interviewDateSavedQuick: 'Interview date saved.',
      interviewDateSaved: 'Interview date saved and applicant notified by email.',
      interviewDateError: 'Could not save interview date. Please try again.',
      interviewDateRequired: 'Select an interview date and time first.',
      noSearchMatch: 'No conversations match your search.',
      selectMessage: 'Select a message from the list to view the conversation.',
      accountSettings: 'Account',
      accountSettingsDesc: 'Manage your account identity and department assignment.',
      jobDescriptionTitle: 'Job Description',
      jobDescriptionDesc: 'Create and update formal job descriptions for each open position in the recruitment pipeline.',
      jobDescriptionEyebrow: 'Human Resources · Documentation',
      jobDescriptionDocumented: 'Positions Documented',
      jobDescriptionGuideTitle: 'Writing Guidelines',
      jobDescriptionGuide1: 'Use clear role titles and reporting lines.',
      jobDescriptionGuide2: 'List core responsibilities in concise bullet points.',
      jobDescriptionGuide3: 'Include qualifications, skills, and work setup expectations.',
      jobDescriptionGuide4: 'Review spelling and tone before publishing to applicants.',
      jobDescriptionEditorTitle: 'Position Details',
      jobDescriptionEditorDesc: 'Select a role below, then draft the official description that will represent Helport for that opening.',
      jobDescriptionSelectPositionHint: 'Select a position above to begin writing the job description.',
      jobDescriptionPosition: 'Position',
      jobDescriptionChoosePosition: 'Select a position',
      jobDescriptionContent: 'Job Description',
      jobDescriptionPlaceholder: 'Enter the job description, responsibilities, and requirements for this position...',
      jobDescriptionSave: 'Save Job Description',
      jobDescriptionSaving: 'Saving...',
      jobDescriptionSaved: 'Job description saved successfully.',
      jobDescriptionSaveFailed: 'Failed to save job description. Please try again.',
      jobDescriptionSelectPosition: 'Please select a position first.',
      accountAccessLevel: 'Access Level',
      accountDepartment: 'Department',
      accountIdLabel: 'Account ID',
      changeProfilePhoto: 'Change photo',
      uploadProfilePhoto: 'Upload photo',
      removeProfilePhoto: 'Remove',
      profilePhotoUpdated: 'Saved.',
      profilePhotoRemoved: 'Removed.',
      profilePhotoUploadFailed: 'Upload failed.',
      profilePhotoInvalid: 'Please choose a JPG, PNG, WEBP, or GIF image under 2MB.',
      adjustProfilePhoto: 'Adjust photo',
      adjustProfilePhotoHint: 'Drag to reposition. Use the slider to zoom before saving.',
      profilePhotoZoom: 'Zoom',
      saveProfilePhoto: 'Save photo',
      savingProfilePhoto: 'Saving...',
      recruitmentHub: 'Recruitment Hub',
      basicInfo: 'Basic Info',
      accountInfo: 'Account Info',
      username: 'Username',
      password: 'Password',
      position: 'Position',
      sections: {
        attachments: 'UPLOADED ATTACHMENTS',
        personal: 'PERSONAL INFORMATION',
        contact: 'CONTACT DETAILS',
        education: 'EDUCATION & WORK HISTORY',
        skills: 'SKILLS & PROFICIENCY',
        application: 'APPLICATION INFORMATION',
        government: 'GOVERNMENT IDS & STATUTORY',
        employment: 'EMPLOYMENT & COMPLIANCE',
        workSetup: 'WORK SETUP & HEALTH',
        profExperience: 'Professional Experience',
        eduBackground: 'Educational Background',
        personalInfo: 'Personal Information',
        emergency: 'Emergency Contact'
      },
      fields: {
        fullName: 'Full Name:',
        dob: 'Date of Birth:',
        gender: 'Gender:',
        civilStatus: 'Civil Status:',
        nationality: 'Nationality:',
        religion: 'Religion:',
        isMinor: 'Is Minor:',
        englishOral: 'English Oral Skills:',
        englishWritten: 'English Written Skills:',
        otherLang: 'Other Languages Known:',
        tin: 'TIN:',
        sss: 'SSS No.:',
        philhealth: 'PhilHealth No.:',
        pagibig: 'Pag-IBIG No.:',
        nbi: 'NBI Status:',
        employed: 'Currently Employed:',
        employer: 'Current Employer:',
        role: 'Current Role:',
        empPeriod: 'Employment Period:',
        notice: 'Notice Period:',
        jobOffer: 'Outstanding Job Offer:',
        bgCheck: 'Background Check Consent:',
        drugFree: 'Drug-Free Workplace:',
        infractions: 'Past Infractions:',
        workSetup: 'Work Setup:',
        shift: 'Shifting Schedule:',
        schedule: 'Work Schedule:',
        health: 'Health Status:',
        declaration: 'Applicant Declaration:',
        privacy: 'Data Privacy Consent:'
      },
      attachments: {
        resume: 'Resume',
        birth: 'PSA/Birth Certificate',
        coe: 'COE/Clearance (Optional)',
        nbi: 'NBI Clearance (Optional)'
      }
    },
    staff: {
      portal: 'Portal',
      recruitment: 'Recruitment',
      appReview: 'Application Review',
      currentTask: 'Current Task',
      pendingReviews: 'Pending Reviews',
      myProfile: 'My Profile',
      notifications: 'Notifications',
      noAlerts: 'No alerts',
      assignedToYou: 'Assigned to You',
      inYourQueue: 'In Your Queue',
      pendingAction: 'Pending Action',
      allClear: 'All clear! No pending applications for your review.',
      noAssigned: 'No applicants are assigned to you yet. Head Admin will assign applicants from Interviewer Management.',
      interviewedBy: 'Interviewed by {name}',
      alreadyInterviewedBy: 'Already being handled by {name}.',
      hideCv: 'Hide Details',
      reviewCv: 'Review Full CV',
      workExperience: 'Work Experience',
      education: 'Education',
      attachments: 'Attachments',
      viewResume: 'View Resume',
      bpoExp: 'BPO Experience',
      notesPlaceholder: 'Add interview notes here...',
      messagesSubtitle: 'Recent submissions from the website contact form.',
      noMessages: 'No messages have been received yet.',
      inbox: 'Inbox',
      writeReply: 'Write your reply...',
      sendReply: 'Send Reply',
      selectMessage: 'Select a message to view the conversation.',
      profileSettings: 'Profile Settings',
      emailAddress: 'Email Address',
      corporateDesignation: 'Corporate Designation',
      saveProfile: 'Save Profile',
      newAssignment: 'New assignment: No. {no} ({position})'
    },
    applicant: {
      myMessages: 'My Messages',
      subtitle: 'You are messaging Admin. Your Application inquiries appear here with the latest replies.',
      missingTitle: 'Required Documents Missing',
      missingIntro: 'Your application requires the following documents to be complete:',
      missingDocsListLabel: 'Documents to complete:',
      missingAction: 'Please update your application form with the required information to complete your submission.',
      missingNotifyBtn: 'Missing',
      missingNotifyHint: 'Send missing documents list to your email',
      missingEmailSending: 'Sending...',
      missingEmailSent: 'Sent!',
      missingEmailFailed: 'Could not send email notification. Please try again.',
      goToStep: 'Go to Step {n} to complete missing documents',
      goToStepShort: 'Step {n}',
      goToForm: 'Go to Application Form',
      emptyList: 'You have no messages yet. Send a message through the contact form and it will appear here.',
      emptySearch: 'No conversations match your search.',
      emptySelect: 'Select a conversation from the list to view your messages with Admin.',
      waitingTitle: 'Application Submitted',
      waitingLead: 'Thank you for applying. Please wait while our recruitment team reviews your application.',
      waitingNote: 'You cannot submit another application at this time. We will notify you once your interview date has been scheduled.',
      waitingNoteScheduled: 'Your interview date is confirmed below. Please check your email for details and be ready at the scheduled time.',
      waitingApplicationNo: 'Application No.',
      waitingStatusLabel: 'Status',
      waitingStatusPending: 'Pending Review',
      waitingInterviewLabel: 'Interview Date',
      waitingInterviewPending: 'To be scheduled',
      waitingGoMessages: 'My Messages',
      waitingBackHome: 'Back to Home',
      developerCredit: 'Developed by: Justine Jaimes Ornido',
      waitingBannerTitle: 'Application On File',
      waitingBannerText: 'Your application has been received. Please wait for your interview date — you cannot apply again unless asked to update missing documents.',
      supportBotTitle: 'Helport Chat',
      supportBotOnline: 'Online',
      newAdminReplyTitle: 'New reply from Admin',
      newAdminReplyBody: 'Helport replied to your message.',
    },
    messagesChat: {
      searchPlaceholder: 'Search sender or text...',
      filterAll: 'All',
      filterUnread: 'Unread',
      filterReplied: 'Replied',
      conversations: 'Conversations',
      writeMessage: 'Type a reply...',
      sendMessage: 'Send',
      sendLabel: 'Send',
      emptyList: 'You have no messages yet.',
      emptySearch: 'No conversations match your search.',
      emptySelect: 'Select a conversation from the list to view messages.',
      talkingWithAdmin: 'Talking: {name}',
      talkingWithAdminRole: 'Talking: {name} · {role}',
      awaitingAdminReply: 'No reply yet',
      activeNow: 'Active now',
      emptyThread: 'No messages yet. Type below to start chatting with Admin.',
      enterToSend: 'Press Enter to send · Shift+Enter for new line',
      conversationCount: '{n} conversations',
      selectMode: 'Select',
      cancelSelect: 'Cancel',
      selectAll: 'Select All',
      deleteSelected: 'Delete Selected',
      deleteConversation: 'Delete conversation',
      deleteConfirm: 'Delete {n} conversation(s)? This cannot be undone.',
      noneSelected: 'No conversations selected',
      backToConversations: 'Back to conversations',
      messageActions: 'Message actions',
      editMessage: 'Edit',
      deleteMessage: 'Delete',
      unsendForYou: 'Unsend for you',
      unsendForEveryone: 'Unsend for everyone',
      saveEdit: 'Save',
      cancelEdit: 'Cancel'
    },
    employment: {
      title: 'Full History & Experience Details',
      empty: 'No detailed employment history recorded for this applicant.',
      entryCount: '{n} record(s)',
      totalExperience: 'Total Experience',
      companyRole: 'Company & Role',
      reasonLeaving: 'Reason for Leaving',
      clearanceCoe: 'Clearance & COE',
      currentlyEmployed: 'Currently Employed',
      currentEmployer: 'Current Employer',
      currentRole: 'Current Role',
      employmentPeriod: 'Employment Period',
      noticePeriod: 'Notice Period',
      outstandingOffer: 'Outstanding Job Offer',
      backgroundCheck: 'Background Check Consent',
      drugFreeWorkplace: 'Drug-Free Workplace',
      pastInfractions: 'Past Infractions'
    },
    assessmentPage: {
      eyebrow: 'Applicant Preparation',
      title: 'Assessment',
      lead: 'Practice voice scripts, take a short typing test, then save your checklist — one section at a time.',
      voiceTraining: 'Voice',
      voiceTrainingNote: 'Record all four scripts. A green dot marks each completed exercise.',
      ex1Title: 'Professional Greeting',
      ex1Script: 'Thank you for calling Helport. My name is [Your Name]. How may I assist you today?',
      ex1Tip: 'Speak warmly, smile while talking, and keep a steady pace.',
      ex2Title: 'Empathy & Acknowledgment',
      ex2Script: 'I completely understand how frustrating that must be. Please allow me a moment while I review your account so I can help you right away.',
      ex2Tip: 'Show empathy first, then reassure the customer you are taking action.',
      ex3Title: 'Hold & Transfer',
      ex3Script: 'May I place you on a brief hold while I check the details for you? I will be back in just a moment. Thank you for your patience.',
      ex3Tip: 'Ask permission before placing on hold and thank the customer for waiting.',
      ex4Title: 'Closing & Summary',
      ex4Script: 'Is there anything else I can help you with today? Thank you for contacting Helport. Have a wonderful day!',
      ex4Tip: 'Confirm the issue is resolved, then close with a positive tone.',
      scriptLabel: 'Script to follow',
      professionalVoiceLabel: 'Professional trainer sample',
      humanVoiceBadge: 'Human voice',
      professionalVoiceNote: 'This is a real recorded voice from a Helport trainer — not AI. Listen carefully and match the tone, pace, and clarity.',
      listenSample: 'Listen to sample',
      playingSample: 'Playing...',
      sampleUnavailable: 'Trainer voice sample is not available yet. Please follow the script above while your team uploads the recording.',
      startRecording: 'Start recording',
      stopRecording: 'Stop recording',
      playbackUnsupported: 'Your browser does not support audio playback.',
      instruction: 'Use headphones if possible. Record in a quiet place and speak clearly at a natural volume.',
      micUnsupported: 'Your browser does not support microphone recording.',
      micDenied: 'Microphone access was denied. Please allow microphone permission and try again.',
      formTitle: 'Checklist',
      formDesc: 'Quick details after your practice — helps us prepare for your interview.',
      fullName: 'Full name',
      fullNamePlaceholder: 'Your full name',
      email: 'Email address',
      emailPlaceholder: 'your.email@example.com',
      completedTraining: 'Completed all voice exercises?',
      selectOption: 'Select an option',
      yes: 'Yes',
      no: 'Not yet',
      englishConfidence: 'English speaking confidence (1–10)',
      notes: 'Notes or questions',
      notesPlaceholder: 'Optional — share anything we should know',
      saveForm: 'Save checklist',
      formRequired: 'Please enter your name and email.',
      formSaved: 'Assessment submitted successfully. Our team will review your voice training.',
      formSaveError: 'Could not save assessment. Please try again.',
      savingForm: 'Saving...',
      scorePrivacyNote: 'Your voice training will be reviewed by Helport admins. Scores are not shown to applicants.',
      progressNote: '{done}/{total} recorded',
      applyCta: 'Apply Now',
      skipToApply: 'Go to Job Application',
      skipToApplyHint: 'On phones and tablets you can apply now. Assessment is optional on this device.',
      continueToTyping: 'Continue to Typing',
      continueToChecklist: 'Continue to Checklist',
      completeVoiceFirst: 'Finish all four voice exercises before moving to the next step.',
      completeTypingFirst: 'Finish the typing test before opening the checklist.',
      completeAssessmentFirst: 'Complete Voice, Typing, and Checklist before applying.',
      voiceCompleteHint: 'Voice exercises complete. You can continue to Typing.',
      typingCompleteHint: 'Typing test complete. You can continue to the Checklist.',
      tabLocked: 'Locked',
      voiceScore: 'Voice Score',
      overallScore: 'Overall Score',
      exerciseScores: 'Exercise Scores',
      noAssessmentYet: 'No assessment submitted yet.',
      assessmentSubmitted: 'Submitted',
      scoreExcellent: 'Excellent',
      scoreGood: 'Good',
      scoreFair: 'Fair',
      scoreNeedsWork: 'Needs Improvement',
      englishConfidenceShort: 'English Confidence',
      completedTrainingShort: 'Training Completed',
      assessmentNotes: 'Applicant Notes',
      exGreeting: 'Greeting',
      exEmpathy: 'Empathy',
      exHold: 'Hold',
      exClosing: 'Closing',
      typingTitle: 'Typing',
      typingDesc: 'Type each prompt quickly and accurately. Timer starts when you begin.',
      typingPromptLabel: 'Prompt',
      typingPrompts: [
        'At Helport, we provide clear communication, empathy, and problem-solving in every customer interaction to deliver a professional service experience.',
        'Thank you for contacting Helport support. How may I assist you today?',
        'I understand your concern and I will do my best to resolve this for you promptly.',
        'Please allow me a moment to review your account while I stay on the line with you.',
        'We appreciate your patience and value your trust in Helport customer service.',
      ],
      typingTimeLeft: 'Time left',
      typingReset: 'Reset test',
      typingPlaceholder: 'Start typing the prompt here...',
      typingWpm: 'WPM',
      typingAccuracy: 'Accuracy',
      typingChars: 'Characters',
      typingScore: 'Score',
      typingTotalScore: 'Total score',
      typingSentences: 'Sentences',
      typingBestWpm: 'Best WPM',
      typingSentenceDone: 'Sentence complete! Next prompt loaded.',
      typingPracticeRound: 'Practice round — your first-try score is already recorded.'
    }
  },
  zh: {
    common: {
      close: '关闭',
      save: '保存',
      cancel: '取消',
      edit: '编辑',
      showPassword: '显示密码',
      hidePassword: '隐藏密码',
      delete: '删除',
      confirm: '确认',
      reject: '拒绝',
      approve: '批准',
      approved: '通过',
      skip: '跳过',
      onhold: '暂停',
      failedInterview: '未通过',
      view: '查看',
      'n/a': '无',
      name: '姓名',
      email: '电子邮箱',
      contact: '联系方式',
      dashboard: '控制台',
      messages: '消息',
      logout: '登出',
      language: '语言',
      english: 'English',
      chinese: '中文 (Chinese)',
      applicant: '申请人',
      admin: '管理员',
      you: '您',
      justNow: '刚刚',
      minutesAgo: '{n} 分钟前',
      hoursAgo: '{n} 小时前',
      daysAgo: '{n} 天前',
      allFieldsRequired: '请填写所有必填项。',
      messageSent: '消息发送成功。',
      loginFailed: '登录失败。',
      noDescription: '暂无该职位的描述。',
      applicationNo: '申请编号',
      noPosition: '无职位'
    },
    category: {
      intro: '探索 Helport 提供的各类职位与服务。选择符合您技能与兴趣的类别。'
    },
    sidebar: {
      helport: 'Helport',
      recruitmentHub: '招聘中心',
      headAdmin: '总管理员',
      menu: '菜单',
      settings: '设置',
      adminControl: '管理控制',
      applicantMonitor: '申请人监控',
      messages: '消息',
      account: '账户',
      jobDescription: '职位描述',
      createAccounts: '创建账户',
      interviewers: '面试官',
      onHold: '暂停',
      jobOffer: '录用通知',
      hired: '已录用',
      pooling: '人才库',
      passedInterview: '面试通过',
      failedInterview: '面试未通过',
      retracted: '已撤回',
      requirementsGuard: '要求检查'
    },
    admin: {
      heroEyebrow: 'Helport 菲律宾 · 招聘',
      heroTitle: '总管理员控制台',
      heroSubtitle: '欢迎回来，{name}。在此跟踪申请、分配面试官并管理招聘流程。',
      totalApplicants: '申请人总数',
      inReview: '审核中',
      applicantMonitor: '申请人监控',
      monitorDesc: '各部门申请状态的实时概览。',
      showMonitorStats: '显示状态概览',
      hideMonitorStats: '隐藏状态概览',
      monitorToggleSummary: '共 {total} · 审核中 {review}',
      appsForReview: '待审核申请',
      queueCount: '队列中有 {n} 份申请',
      noAssigned: '暂无分配给您的申请人。总管理员将在面试官管理中分配。',
      noDepartmentQueue: '您的部门队列暂无申请。',
      noPending: '暂无待处理申请。',
      interviewedByLabel: '面试官',
      alreadyInterviewedBy: '已由 {name} 处理。',
      viewResume: '查看电子简历',
      closeResume: '关闭简历',
      reviewDetails: '查看全部详情',
      hideDetails: '隐藏全部详情',
      remarksPlaceholder: '在此输入备注供总管理员审阅...',
      saveRemarks: '保存备注',
      remarksSaved: '备注已成功保存。',
      remarksSaveFailed: '备注保存失败。',
      savedRemarksHistory: '已保存备注：',
      historyRemarks: '历史 / 备注：',
      recruiterRemarks: '招聘官 / 面试官备注',
      createAdminTitle: '创建账户',
      createAdminDesc: '创建并管理组织内各部门管理员账户。',
      createDepartmentAccount: '创建部门账户',
      createAdminAccountBtn: '创建管理员账户',
      selectRole: '选择角色',
      selectPositionDept: '选择职位 / 部门',
      noRegisteredAccounts: '暂无已注册账户。',
      registeredAccountsCount: '已注册账户 {n} 个',
      searchRegisteredAccounts: '按姓名、邮箱或职位搜索…',
      registeredAccountsSearchEmpty: '没有匹配的账户。',
      editAdminTitle: '编辑管理员',
      changePasswordTitle: '修改密码',
      newPassword: '新密码',
      confirmPassword: '确认密码',
      saveChanges: '保存更改',
      changePasswordBtn: '修改密码',
      registeredAccounts: '已注册账户',
      interviewerTitle: '面试官',
      interviewerDesc: '管理各部门面试官及其分配的申请人。',
      interviewerDescAuto: '将申请人分配给 HR 和客户面试官。Team Leader 与 Operations 共享部门队列，任一成员均可处理申请。',
      deptApplications: '队列中的申请',
      deptStageActivity: '谁移动了申请',
      noPendingInDept: '该部门暂无待处理申请。',
      noStageActivityYet: '该部门暂无申请流转记录。',
      noHandledApplicantsYet: '该成员尚未移动任何申请。',
      handledBy: '处理人：{name}',
      awaitingAction: '等待处理',
      teamMembers: '团队成员',
      noInterviewersInDept: '该部门暂无面试官。',
      assignNewApplicant: '分配新申请人',
      assignApplicantLabel: '分配申请人',
      selectApplicant: '选择申请人...',
      noAssignableApplicants: '该阶段暂无可分配的申请人。',
      savingAssignment: '保存中...',
      assignedApplicantsCount: '已分配（{n}）',
      interviewedApplicantsCount: '已流转（{n}）',
      deptQueueCount: '待处理 {n}',
      noInterviewsYet: '暂无已分配申请人',
      searchInterviewers: '按姓名或邮箱搜索…',
      recentMoves: '最近流转',
      assignShort: '分配',
      memberSingular: '成员',
      memberPlural: '成员',
      deptHr: 'HR',
      deptOps: '运营',
      deptTl: 'Team Leader',
      deptClient: '客户',
      onHoldTitle: '暂停',
      onHoldDesc: '在发出正式录用通知前审阅当前暂停的申请人。',
      onHoldCount: '暂停申请数',
      onHoldEmpty: '当前没有暂停的申请人。',
      onHoldRemarksPlaceholder: '在此输入招聘官备注...',
      onHoldFields: {
        applicantName: '申请人姓名（姓、名、中间名、后缀）',
        positionRole: '职位/角色',
        mobileNo: '手机号码',
        emailAddress: '电子邮箱',
        residentialAddress: '居住地址',
        dateOfApplication: '申请日期',
        lastInterview: '最近面试日期/评估',
        rehireEligibility: '再录用资格（是/否）',
        reemploymentCount: '再就业次数（0-5）',
        sourceOfReferral: '推荐来源',
        referredBy: '推荐人：',
        cvResume: '简历',
        dateOfBirth: '出生日期',
        gender: '性别',
        tin: '税务识别号',
        sss: 'SSS 编号',
        phic: 'PHIC 编号',
        hdmf: 'HDMF 编号',
        nbiStatus: 'NBI 状态',
        recruitersRemarks: '招聘官备注'
      },
      jobOfferTitle: '录用通知',
      jobOfferDesc: '审阅已发出录用通知的申请人。',
      offersIssued: '已发录用通知',
      jobOfferEmpty: '录用通知阶段暂无申请人。',
      jobOfferRemarksPlaceholder: '在此输入最终招聘官备注...',
      recruitersFinalRemarks: '招聘官最终备注',
      hiredTitle: '已录用',
      hiredDesc: '跟踪已录用申请人，并发送他们需要提交的上岗要求。',
      hiredCount: '已录用',
      hiredEmpty: '暂无已录用的申请人。',
      hiredRemarksPlaceholder: '在此添加入职或最终备注...',
      hiredRequirementsTitle: '需提交的上岗要求',
      hiredRequirementsDesc: '查看以下各项要求，并通知申请人提交尚未完成的文件。',
      requirementSubmitted: '已提交',
      requirementPending: '待提交',
      sendRequirementNotice: '发送通知',
      sendAllPendingRequirements: '发送所有待提交要求',
      hiredPendingCount: '{n} 项待提交',
      poolingTitle: '人才库',
      poolingDesc: '审阅当前处于人才库阶段的申请人。',
      inPooling: '人才库中',
      poolingEmpty: '人才库阶段暂无申请人。',
      passedInterviewTitle: '面试通过',
      passedInterviewDesc: '查看已通过面试的申请人。',
      passedInterviewEmpty: '暂无标记为面试通过的申请人。',
      failedInterviewTitle: '面试未通过',
      failedInterviewDesc: '查看面试未通过的申请人。',
      failedInterviewEmpty: '暂无标记为面试未通过的申请人。',
      returnToInterview: '返回面试审核',
      noInterviewRemarks: '暂无面试备注。',
      retractedTitle: '已撤回',
      retractedDesc: '审阅已撤回申请的申请人。',
      retractedCount: '已撤回',
      retractedEmpty: '暂无已撤回的申请。',
      segment: '业务板块',
      assessment: '评估',
      voiceScore: '语音分数',
      overallScore: '总分',
      exerciseScores: '分项得分',
      noAssessmentYet: '暂无评估',
      scoreExcellent: '优秀',
      scoreGood: '良好',
      scoreFair: '一般',
      scoreNeedsWork: '需改进',
      englishConfidenceShort: '英语自信度',
      completedTrainingShort: '完成训练',
      assessmentNotes: '申请人备注',
      exGreeting: '问候',
      exEmpathy: '共情',
      exHold: '等候',
      exClosing: '结束',
      assessmentStatus: '状态',
      reasonForRetraction: '撤回原因：',
      retractedRemarksPlaceholder: '在此输入最终招聘官备注...',
      guardTitle: '要求检查',
      guardDesc: '监控缺少或不完整必填文件的申请人。',
      guardEmpty: '所有受监控的申请目前均符合要求检查。',
      flagged: '已标记',
      emailAddress: '电子邮箱：',
      contactNumber: '联系电话：',
      applicationDate: '申请日期：',
      positionNotSpecified: '未指定职位',
      missingDocuments: '缺失文件：',
      issueJobOffer: '发出录用通知',
      assignedAccountLabel: '已分配账户：',
      accountUnassigned: '未分配',
      markHired: '标记为已录用',
      markRetracted: '撤回',
      retractConfirm: '撤回 {name}（申请编号 {no}）的申请？所有已提交的答案和要求将被删除，仅保留姓名和申请编号。',
      searchApplicationNo: '按申请编号搜索',
      retractedSearchEmpty: '没有匹配该申请编号的已撤回申请。',
      sendNotification: '发送通知',
      noFileAlert: '未找到该文件的上传记录。请要求申请人重新提交附件。',
      statTotal: '申请人总数',
      statPendingHr: '待 HR 审核',
      statPendingOps: '待运营审核',
      statPendingTl: '待组长审核',
      statPendingClient: '待客户审核',
      statPendingHeadAdmin: '待总管理员终审',
      pipelineHr: 'HR',
      pipelineOperations: '运营',
      pipelineTeamLeader: '组长',
      pipelineClient: '客户',
      pipelineHeadAdmin: '总管理员',
      pipelineWaitingFor: '需等待 {stage} 审核通过后，您才能审阅。',
      pipelineRejected: '申请人已被拒绝，流程已终止。',
      pipelineFailedInterview: '申请人面试未通过，流程已终止。',
      pipelineAlreadyPassed: '该申请人已通过您的审核阶段。',
      pipelineNotYourTurn: '尚未轮到您审阅该申请人。',
      pipelineHeadAdminWaiting: '申请人仍在部门审核流程中。',
      statHired: '已录用',
      statOnhold: '暂停',
      statRejected: '已拒绝',
      statJobOffer: '录用通知',
      statPooling: '人才库',
      statPassedInterview: '面试通过',
      statFailedInterview: '面试未通过',
      statusPassed: '通过',
      statusFailed: '未通过',
      statRetracted: '已撤回',
      messagesSubtitleAdmin: 'Head Admin 与 HR 共享收件箱，可查看每位申请人的对接管理员。',
      newApplicantChatTitle: '{name} 发来新消息',
      newApplicantChatBody: '有申请人发送了新消息。',
      messagesSubtitleAssigned: '此处显示分配给您的申请人的消息。',
      searchApplicants: '按姓名或邮箱搜索申请人',
      noMessagesAdmin: '暂无提交的消息。',
      noMessagesAssigned: '暂无分配给您的申请人消息。',
      interviewScheduleLabel: '面试安排',
      interviewDateLabel: '日期',
      interviewTimeLabel: '时间',
      currentInterviewDate: '已安排：{date}',
      setInterviewDate: '设置面试日期',
      interviewDateSaving: '保存中...',
      interviewDateSavedQuick: '面试日期已保存。',
      interviewDateSaved: '面试日期已保存，并已通过邮件通知申请人。',
      interviewDateError: '无法保存面试日期，请重试。',
      interviewDateRequired: '请先选择面试日期和时间。',
      noSearchMatch: '没有匹配的对话。',
      selectMessage: '请从列表中选择消息以查看对话。',
      accountSettings: '账户',
      accountSettingsDesc: '管理您的账户身份与部门分配。',
      jobDescriptionTitle: '职位描述',
      jobDescriptionDesc: '为招聘流程中的每个开放职位创建和更新正式职位描述。',
      jobDescriptionEyebrow: '人力资源 · 文档管理',
      jobDescriptionDocumented: '已编写职位',
      jobDescriptionGuideTitle: '编写指南',
      jobDescriptionGuide1: '使用清晰的职位名称和汇报关系。',
      jobDescriptionGuide2: '以简洁要点列出核心职责。',
      jobDescriptionGuide3: '包含资格要求、技能和工作安排说明。',
      jobDescriptionGuide4: '发布前请检查拼写和语气是否专业。',
      jobDescriptionEditorTitle: '职位详情',
      jobDescriptionEditorDesc: '请先选择职位，然后撰写代表 Helport 该岗位的正式描述。',
      jobDescriptionSelectPositionHint: '请先在上方选择职位，再开始编写职位描述。',
      jobDescriptionPosition: '职位',
      jobDescriptionChoosePosition: '选择职位',
      jobDescriptionContent: '职位描述',
      jobDescriptionPlaceholder: '请输入该职位的描述、职责和要求...',
      jobDescriptionSave: '保存职位描述',
      jobDescriptionSaving: '保存中...',
      jobDescriptionSaved: '职位描述保存成功。',
      jobDescriptionSaveFailed: '保存职位描述失败，请重试。',
      jobDescriptionSelectPosition: '请先选择职位。',
      accountAccessLevel: '访问级别',
      accountDepartment: '部门',
      accountIdLabel: '账户 ID',
      changeProfilePhoto: '更换照片',
      uploadProfilePhoto: '上传照片',
      removeProfilePhoto: '移除',
      profilePhotoUpdated: '已保存。',
      profilePhotoRemoved: '已移除。',
      profilePhotoUploadFailed: '上传失败。',
      profilePhotoInvalid: '请选择不超过 2MB 的 JPG、PNG、WEBP 或 GIF 图片。',
      adjustProfilePhoto: '调整照片',
      adjustProfilePhotoHint: '拖动以调整位置，使用滑块缩放后再保存。',
      profilePhotoZoom: '缩放',
      saveProfilePhoto: '保存照片',
      savingProfilePhoto: '保存中...',
      recruitmentHub: '招聘中心',
      basicInfo: '基本信息',
      accountInfo: '账户信息',
      username: '用户名',
      password: '密码',
      position: '职位',
      sections: {
        attachments: '已上传附件',
        personal: '个人信息',
        contact: '联系方式',
        education: '教育与工作经历',
        skills: '技能与熟练度',
        application: '申请信息',
        government: '政府证件与社保',
        employment: '就业与合规',
        workSetup: '工作安排与健康',
        profExperience: '专业经历',
        eduBackground: '教育背景',
        personalInfo: '个人信息',
        emergency: '紧急联系人'
      },
      fields: {
        fullName: '全名：',
        dob: '出生日期：',
        gender: '性别：',
        civilStatus: '婚姻状况：',
        nationality: '国籍：',
        religion: '宗教：',
        isMinor: '是否未成年：',
        englishOral: '英语口语：',
        englishWritten: '英语写作：',
        otherLang: '其他语言：',
        tin: '税号 (TIN)：',
        sss: 'SSS 编号：',
        philhealth: 'PhilHealth 编号：',
        pagibig: 'Pag-IBIG 编号：',
        nbi: 'NBI 状态：',
        employed: '目前在职：',
        employer: '当前雇主：',
        role: '当前职位：',
        empPeriod: '在职期间：',
        notice: '离职通知期：',
        jobOffer: '待确认录用：',
        bgCheck: '背景调查同意：',
        drugFree: '无毒工作场所：',
        infractions: '过往违规：',
        workSetup: '工作方式：',
        shift: '轮班安排：',
        schedule: '工作时间：',
        health: '健康状况：',
        declaration: '申请人声明：',
        privacy: '数据隐私同意：'
      },
      attachments: {
        resume: '简历',
        birth: 'PSA/出生证明',
        coe: 'COE/离职证明（选填）',
        nbi: 'NBI 无犯罪证明（选填）'
      }
    },
    staff: {
      portal: '门户',
      recruitment: '招聘',
      appReview: '申请审核',
      currentTask: '当前任务',
      pendingReviews: '待审核',
      myProfile: '我的资料',
      notifications: '通知',
      noAlerts: '暂无提醒',
      assignedToYou: '分配给您的',
      inYourQueue: '您的队列',
      pendingAction: '待处理',
      allClear: '全部完成！暂无待您审核的申请。',
      noAssigned: '暂无分配给您的申请人。总管理员将在面试官管理中分配。',
      interviewedBy: '面试官：{name}',
      alreadyInterviewedBy: '已由 {name} 处理。',
      hideCv: '隐藏详情',
      reviewCv: '查看完整简历',
      workExperience: '工作经历',
      education: '教育背景',
      attachments: '附件',
      viewResume: '查看简历',
      bpoExp: 'BPO 经验',
      notesPlaceholder: '在此添加面试备注...',
      messagesSubtitle: '网站联系表单的最新提交。',
      noMessages: '暂未收到消息。',
      inbox: '收件箱',
      writeReply: '输入回复...',
      sendReply: '发送回复',
      selectMessage: '请选择消息以查看对话。',
      profileSettings: '资料设置',
      emailAddress: '电子邮箱',
      corporateDesignation: '公司职务',
      saveProfile: '保存资料',
      newAssignment: '新分配：编号 {no}（{position}）'
    },
    applicant: {
      myMessages: '我的消息',
      subtitle: '您正在与管理员沟通。您的申请咨询及最新回复将显示在此处。',
      missingTitle: '缺少必填文件',
      missingIntro: '您的申请需要以下文件才算完整：',
      missingDocsListLabel: '待补全文件：',
      missingAction: '请更新申请表并补充所需信息以完成提交。',
      missingNotifyBtn: '缺失通知',
      missingNotifyHint: '将缺失文件清单发送到您的邮箱',
      missingEmailSending: '发送中...',
      missingEmailSent: '已发送！',
      missingEmailFailed: '无法发送邮件通知，请重试。',
      goToStep: '前往第 {n} 步补全缺失文件',
      goToStepShort: '第 {n} 步',
      goToForm: '前往申请表',
      emptyList: '您暂无消息。通过联系表单发送的消息将显示在此处。',
      emptySearch: '没有匹配的对话。',
      emptySelect: '请从列表中选择对话以查看与管理员的往来消息。',
      waitingTitle: '申请已提交',
      waitingLead: '感谢您的申请。请耐心等待，我们的招聘团队正在审核您的申请。',
      waitingNote: '目前无法再次提交申请。面试日期确定后，我们将通知您。',
      waitingNoteScheduled: '您的面试日期已确认如下。请查看邮件了解详情，并准时参加面试。',
      waitingApplicationNo: '申请编号',
      waitingStatusLabel: '状态',
      waitingStatusPending: '待审核',
      waitingInterviewLabel: '面试日期',
      waitingInterviewPending: '待安排',
      waitingGoMessages: '我的消息',
      waitingBackHome: '返回首页',
      developerCredit: '开发者：Justine Jaimes Ornido',
      waitingBannerTitle: '申请已存档',
      waitingBannerText: '我们已收到您的申请。请等待面试日期通知——除非被要求补充缺失文件，否则无法再次申请。',
      supportBotTitle: 'Helport 聊天',
      supportBotOnline: '在线',
      newAdminReplyTitle: '管理员有新回复',
      newAdminReplyBody: 'Helport 已回复您的消息。',
    },
    messagesChat: {
      searchPlaceholder: '搜索发件人或内容...',
      filterAll: '全部',
      filterUnread: '未读',
      filterReplied: '已回复',
      conversations: '对话',
      writeMessage: '输入回复...',
      sendMessage: '发送',
      sendLabel: '发送',
      emptyList: '您暂无消息。',
      emptySearch: '没有匹配的对话。',
      emptySelect: '请从列表中选择对话以查看消息。',
      talkingWithAdmin: '对接管理员：{name}',
      talkingWithAdminRole: '对接管理员：{name} · {role}',
      awaitingAdminReply: '暂无回复',
      activeNow: '当前在线',
      emptyThread: '暂无消息。在下方输入即可开始与管理员聊天。',
      enterToSend: '按 Enter 发送 · Shift+Enter 换行',
      conversationCount: '{n} 条对话',
      selectMode: '选择',
      cancelSelect: '取消',
      selectAll: '全选',
      deleteSelected: '删除所选',
      deleteConversation: '删除对话',
      deleteConfirm: '确定删除 {n} 条对话？此操作无法撤销。',
      noneSelected: '未选择任何对话',
      backToConversations: '返回对话列表',
      messageActions: '消息操作',
      editMessage: '编辑',
      deleteMessage: '删除',
      unsendForYou: '仅对自己取消发送',
      unsendForEveryone: '对所有人取消发送',
      saveEdit: '保存',
      cancelEdit: '取消'
    },
    employment: {
      title: '完整工作经历与经验详情',
      empty: '该申请人暂无详细工作经历记录。',
      entryCount: '{n} 条记录',
      totalExperience: '总工作经验',
      companyRole: '公司与职位',
      reasonLeaving: '离职原因',
      clearanceCoe: '离职证明与 COE',
      currentlyEmployed: '当前是否在职',
      currentEmployer: '当前雇主',
      currentRole: '当前职位',
      employmentPeriod: '在职期间',
      noticePeriod: '通知期',
      outstandingOffer: '是否有待确认的工作邀约',
      backgroundCheck: '背景调查同意',
      drugFreeWorkplace: '无毒工作场所承诺',
      pastInfractions: '过往违规记录'
    },
    assessmentPage: {
      eyebrow: '申请人准备',
      title: '评估',
      lead: '练习语音脚本、完成简短打字测试，然后保存清单 — 一次只显示一个部分。',
      voiceTraining: '语音',
      voiceTrainingNote: '请完成全部四项录音。绿色标记表示该项已完成。',
      ex1Title: '专业问候',
      ex1Script: '感谢您致电 Helport。我是[您的姓名]。请问今天有什么可以帮您？',
      ex1Tip: '语气要热情友好，说话时保持微笑，语速平稳。',
      ex2Title: '共情与确认',
      ex2Script: '我完全理解您此刻的心情。请给我一点时间查看您的账户，我会尽快为您处理。',
      ex2Tip: '先表达理解，再让客户知道您正在采取行动。',
      ex3Title: '等候与转接',
      ex3Script: '请问我可以将您暂时等候一下，以便为您查询详情吗？我很快就会回来。感谢您的耐心等候。',
      ex3Tip: '等候前需征得同意，并感谢客户的耐心。',
      ex4Title: '结束与总结',
      ex4Script: '请问还有其他可以帮您的吗？感谢您联系 Helport。祝您有美好的一天！',
      ex4Tip: '确认问题已解决，以积极语气结束通话。',
      scriptLabel: '请跟读以下脚本',
      professionalVoiceLabel: '专业培训师示例',
      humanVoiceBadge: '真人录音',
      professionalVoiceNote: '这是 Helport 培训师的真实录音，不是 AI 语音。请仔细聆听并模仿语气、语速和清晰度。',
      listenSample: '播放示例',
      playingSample: '播放中...',
      sampleUnavailable: '培训师录音暂不可用。请先按照上方脚本练习，待录音上传后即可播放。',
      startRecording: '开始录音',
      stopRecording: '停止录音',
      playbackUnsupported: '您的浏览器不支持音频播放。',
      instruction: '建议使用耳机，在安静环境中录音，以自然音量清晰发音。',
      micUnsupported: '您的浏览器不支持麦克风录音。',
      micDenied: '无法访问麦克风。请允许麦克风权限后重试。',
      formTitle: '清单',
      formDesc: '练习后填写简短信息，便于我们为面试做准备。',
      fullName: '姓名',
      fullNamePlaceholder: '您的全名',
      email: '电子邮箱',
      emailPlaceholder: 'your.email@example.com',
      completedTraining: '是否已完成全部语音练习？',
      selectOption: '请选择',
      yes: '是',
      no: '尚未完成',
      englishConfidence: '英语口语自信度（1–10）',
      notes: '备注或问题',
      notesPlaceholder: '选填 — 可告知我们需要了解的信息',
      saveForm: '保存清单',
      formRequired: '请填写姓名和电子邮箱。',
      formSaved: '评估已成功提交。我们的团队将审核您的语音训练。',
      formSaveError: '无法保存评估，请重试。',
      savingForm: '保存中...',
      scorePrivacyNote: '您的语音训练将由 Helport 管理员审核。申请人不会看到分数。',
      progressNote: '已录 {done}/{total}',
      applyCta: '立即申请',
      skipToApply: '前往职位申请',
      skipToApplyHint: '手机和平板上可直接申请。此设备上评估为可选。',
      continueToTyping: '继续打字测试',
      continueToChecklist: '继续填写清单',
      completeVoiceFirst: '请先完成全部四项语音练习，再进入下一步。',
      completeTypingFirst: '请先完成打字测试，再打开清单。',
      completeAssessmentFirst: '请先完成语音、打字和清单后再申请。',
      voiceCompleteHint: '语音练习已完成，可以继续打字测试。',
      typingCompleteHint: '打字测试已完成，可以继续填写清单。',
      tabLocked: '未解锁',
      voiceScore: '语音分数',
      overallScore: '总分',
      exerciseScores: '各项分数',
      noAssessmentYet: '尚未提交评估。',
      assessmentSubmitted: '已提交',
      scoreExcellent: '优秀',
      scoreGood: '良好',
      scoreFair: '一般',
      scoreNeedsWork: '需改进',
      englishConfidenceShort: '英语自信度',
      completedTrainingShort: '完成训练',
      assessmentNotes: '申请人备注',
      exGreeting: '问候',
      exEmpathy: '共情',
      exHold: '等候',
      exClosing: '结束',
      typingTitle: '打字',
      typingDesc: '请快速且准确地输入每句提示。开始输入后计时器启动。',
      typingPromptLabel: '提示内容',
      typingPrompts: [
        '在 Helport，我们在每一次客户互动中都提供清晰沟通、共情与问题解决能力，以交付专业的服务体验。',
        '感谢您联系 Helport 客服。请问今天有什么可以帮到您？',
        '我理解您的顾虑，我会尽力尽快为您解决这个问题。',
        '请稍等片刻，我会在线为您查看账户信息。',
        '感谢您的耐心，也感谢您对 Helport 客服团队的信任。',
      ],
      typingTimeLeft: '剩余时间',
      typingReset: '重置测试',
      typingPlaceholder: '请在此开始输入上述内容...',
      typingWpm: '每分钟字数',
      typingAccuracy: '准确率',
      typingChars: '输入字符',
      typingScore: '得分',
      typingTotalScore: '总分',
      typingSentences: '完成句数',
      typingBestWpm: '最高 WPM',
      typingSentenceDone: '本句完成！已加载下一句。',
      typingPracticeRound: '练习轮次 — 首次得分已记录，不再累计。'
    }
  }
};

export const getT = (lang = 'en') => uiTranslations[lang] || uiTranslations.en;

export const formatT = (template, vars = {}) =>
  String(template).replace(/\{(\w+)\}/g, (_, key) => (vars[key] != null ? vars[key] : `{${key}}`));
